export default __webpack_public_path__ + "static/media/card-insta-suvinil4.250158e5.jpg";